jQuery(document).ready(function ($) {

  $('.news-item, article.event').addClass('fade');

  window.odometerOptions = {
    animation: 'count'
  };

  $('.alerts .close').on('click', function () {
    $('.alerts').addClass('closed');
  });


  var isInViewport = function (elem) {
    if (elem !== null) {
      var bounding = elem.getBoundingClientRect();
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  };


  $(document, 'body').scroll(function () {
    var odometer = document.querySelector('.odometer');
    var news = document.querySelector('.featured-news > h2');
    var events = document.querySelector('.events-container > h2');

    if (isInViewport(odometer)) {
      $('.odometer').each(function (index) {
        var timeout = index * 500;
        $(this).delay(timeout).queue(function () { $(this).text($(this).data('number')); });
      });
    }

    if (isInViewport(news)) {
      $('.news-item').each(function (index) {
        var timeout = index * 250;
        $(this).delay(timeout).queue(function () { $(this).addClass('in'); });
      });
    }

    if (isInViewport(events)) {
      $('article.event').each(function (index) {
        var timeout = index * 250;
        $(this).delay(timeout).queue(function () { $(this).addClass('in'); });
      });
    }

  });

  $(document, 'body').scroll();
});